import React, { useId } from "react";
import { cn } from "@/lib/utils";

interface CircleFillXIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  circleColor?: string;
  xColor?: string;
}

export const CircleFillXIcon: React.FC<CircleFillXIconProps> = ({
  className,
  circleColor = "#606064",
  xColor = "#F5F5F6",
  ...props
}) => {
  const clipId = useId();
  return (
    <svg
      width="20"
      height="20"
      viewBox="-2 -2 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M7.99999 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 7.99999 1.33325C4.3181 1.33325 1.33333 4.31802 1.33333 7.99992C1.33333 11.6818 4.3181 14.6666 7.99999 14.6666Z"
          fill={circleColor}
          stroke={circleColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 6L6 10"
          stroke={xColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6L10 10"
          stroke={xColor}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
